import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useFormState } from "react-final-form";
import RefinementDynamicFields from "./components/RefinementDynamicFields";
import CommonDynamicFields from "./components/CommonDynamicFields";
import { refinementResultByParameterIdSelector } from "store/cell-model/cell-model.selectors";
const DynamicFields = ({ name, children, ...restProps }) => {
    const formState = useFormState();
    const values = useMemo(() => formState.values?.[name], [formState.values, name]);
    const refinementResult = useSelector(refinementResultByParameterIdSelector(values?.parameterId));
    return refinementResult ? (React.createElement(RefinementDynamicFields, { refinementResult: refinementResult }, children)) : (React.createElement(CommonDynamicFields, { name: name, values: values, ...restProps }, children));
};
export default DynamicFields;
